import { render, staticRenderFns } from "./GoodsConfen.vue?vue&type=template&id=77354019&scoped=true&"
import script from "./GoodsConfen.vue?vue&type=script&lang=js&"
export * from "./GoodsConfen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77354019",
  null
  
)

export default component.exports